export const environment = {
  production: false,
  ApiUrl:'https://api-edito-tds.cftravel.net/api',
  LoginUrl:'/login',
  MidOfficeUrl:'https://front-midoffice-tds.cftravel.net',
  debug : true,
  activeEnvironment:'development'

};
